import RestService from './RestService';


export async function getPendingApprovals() {
    const res = await RestService.performRestOpNext(`general/invoke-authorizer`, {
        service: "PendingReviewService",
        method: "getPendingApprovals",
        params: {}
    });
    return res;
}


export async function approve(type, id) {
    await RestService.performRestOpNext(`general/invoke-authorizer`, {
        service: "PendingReviewService",
        method: "approve",
        params: { type, id }
    });
}

export async function disapprove(type, id) {
    await RestService.performRestOpNext(`general/invoke-authorizer`, {
        service: "PendingReviewService",
        method: "disapprove",
        params: { type, id }
    });
}
